"use strict";

exports.__esModule = true;
exports.getImageFiltersSchema = getImageFiltersSchema;
exports.getImageFiltersField = getImageFiltersField;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getImageFiltersSchema(props) {
  const defaultSchema = {
    "type": "object",
    "properties": {
      "saturation": {
        "type": "number"
      },
      "grayscale": {
        "type": "number"
      },
      "brightness": {
        "type": "number"
      },
      "opacity": {
        "type": "number"
      },
      "contrast": {
        "type": "number"
      },
      "blur": {
        "type": "number"
      },
      "invert": {
        "type": "number"
      }
    }
  };
  return defaultSchema;
}

function getImageFiltersField(props) {
  const schema = getImageFiltersSchema(props);
  return _extends({}, props, {
    schema: schema,
    uiSchema: _extends({}, props.uiSchema, {
      "ui:field": "imageFilters"
    })
  });
}